"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactRouterHashLink = require("react-router-hash-link");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ReactLink = function ReactLink(props) {
  var REACT_APP_SPA = process.env.REACT_APP_SPA;
  var to = props.to;

  var propsClone = _objectSpread({}, props);

  if (REACT_APP_SPA === "true" && (to === null || to === void 0 ? void 0 : to.indexOf("http://")) === -1 && (to === null || to === void 0 ? void 0 : to.indexOf("https://")) === -1 && (to === null || to === void 0 ? void 0 : to.indexOf("#")) === -1 && (to === null || to === void 0 ? void 0 : to.indexOf("//")) !== 0) {
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, _extends({
      to: to
    }, propsClone), propsClone.children);
  }

  if (REACT_APP_SPA === "true" && to.indexOf("#") === 0) {
    return /*#__PURE__*/_react.default.createElement(_reactRouterHashLink.HashLink, _extends({
      to: to
    }, propsClone), propsClone.children);
  }

  propsClone.to = null;
  return /*#__PURE__*/_react.default.createElement("a", _extends({
    href: to
  }, propsClone), propsClone.children);
};

ReactLink.propTypes = {
  to: _propTypes.default.string.isRequired
};
var _default = ReactLink;
exports.default = _default;